<script setup lang="ts">
import type { Outcome } from '../api/client.js';

/**
 * Faixa de resultado.
 *
 * Cada desfecho tem aparência PRÓPRIA. Um conflito não pode parecer sucesso, e
 * uma pendência precisa dizer que ainda não foi aplicada — a diferença entre
 * "gravado" e "recebido" é a única informação que o operador tem.
 */
defineProps<{ outcome: Outcome | null }>();
</script>

<template>
  <p
    v-if="outcome"
    class="outcome"
    :class="`outcome--${outcome.kind}`"
    role="status"
    :data-kind="outcome.kind"
  >
    <strong>{{
      outcome.kind === 'applied'
        ? 'Aplicado'
        : outcome.kind === 'duplicate'
          ? 'Repetido'
          : outcome.kind === 'pending'
            ? 'Pendente'
            : outcome.kind === 'conflict'
              ? 'Conflito'
              : 'Recusado'
    }}</strong>
    <span>{{ outcome.message }}</span>
    <code v-if="outcome.errorCode">{{ outcome.errorCode }}</code>
  </p>
</template>

<style scoped>
.outcome { display: flex; gap: .5rem; align-items: center; padding: .5rem .75rem; border-radius: 4px; }
.outcome--applied { background: #e6f4ea; border: 1px solid #1e8e3e; }
.outcome--duplicate { background: #e8f0fe; border: 1px solid #1a73e8; }
.outcome--pending { background: #fef7e0; border: 1px solid #f9ab00; }
.outcome--conflict { background: #fce8e6; border: 1px solid #d93025; }
.outcome--rejected { background: #fce8e6; border: 1px solid #d93025; }
</style>
